<template>
  <div v-if='isLoading'>
    <v-container class='wide-container'>
      <wc-loading line msg='Getting schedule details'></wc-loading>
    </v-container>
  </div>
  <div v-else>
    <wc-section-title :title='title' :loading='isLoading || isLoadingUnscheduled || isLoadingCalData'
      fullWidth></wc-section-title>
    <div class='main-wrapper'>
      <div class='unscheduled'>
        <unscheduled ref='unscheduled' :unscheduled='unscheduled' :isLoading='isLoadingUnscheduled || isLoadingCalData'
          @deselect='deselect' @select='select' @moveWOs='moveWOs' @openQuickView='openQuickView'
          @openCrewVisits='openCrewVisits'></unscheduled>
      </div>
      <div class='schedule-view'>
        <router-view :isLoading='isLoadingCalData || routesLoading > 0' :routes='routes' :schedule='schedule'
          @clearScheduleData='clearScheduleData' @getFullRoute='getFullRoute' @openCrewVisits='openCrewVisits'
          @deleteRoute='deleteRoute' @addRoute='addRoute' @deselect='deselect' @select='select'
          @updateRoute='updateRoute' @dateChange='dateChange' @moveWOs='moveWOs' @openQuickView='openQuickView'
          @archiveWOs='archiveWOs'></router-view>
      </div>
    </div>

    <crew-visits-dialog :showDialog='showCrewVisits' @close='showCrewVisits = false' :wo='woCV'></crew-visits-dialog>

    <wo-quick-view v-if='woQV' :showDialog='showQuickView' :wo='woQV' :schedule='schedule' @loadNext='nextWO'
      @loadPrev='prevWO' @close='showQuickView = false' @updateQuickView='updateQuickView'></wo-quick-view>
  </div>
</template>

<script>
import miscServices from '@/services/misc';
import scheduleAPI from '@/api/schedule';
import wosAPI from '@/modules/wos/api/';
import Unscheduled from './Unscheduled';
import woQuickView from './WOQuickView';
import CrewVisitsDialog from './CrewVisitsDialog';
import moment from 'moment';
import _ from 'lodash';

export default {
  name: 'schedule-base',
  data: () => ({
    isLoading: false,
    isLoadingCalData: false,
    isLoadingUnscheduled: false,
    routesLoading: 0,
    showQuickView: false,
    showCrewVisits: false,
    schedule: null,
    routes: [],
    reminders: [],
    unscheduled: [],
    activeCalendars: [],
    activeSchedules: [],
    subNav: [],
    extraNav: [],
    woQV: null,
    woCV: null,
    from: '',
    to: ''
  }),
  computed: {
    title() {
      if (this.schedule) {
        return this.schedule.name
      }
      return ''
    },
    storeRoutes() {
      return this.$store.state.schedule.selectedRoutes
    }
  },
  mounted() {
    this.$store.state.nav.showDrawer = false
    this.$store.dispatch('deselectAll')
    this.from = this.$route.params.date
    this.to = this.$route.params.date
    this.getData()
    let ws = ''
    if (this.$axios.defaults.baseURL === 'http://127.0.0.1:8000/api/') {
      ws = 'ws://localhost:8000/schedule/'
    } else if (this.$axios.defaults.baseURL === 'https://api-dev.capitalirrigation.com/api/') {
      ws = 'wss://api-dev.capitalirrigation.com/schedule/'
    } else if (this.$axios.defaults.baseURL === 'https://api.capitalirrigation.com/api/') {
      ws = 'wss://api.capitalirrigation.com/schedule/'
    }
    console.log("ws is ",  ws);
    console.log("base url is ", this.$axios.defaults.baseURL);
    ws += '?token=' + this.$store.state.auth.token
    this.$connect(ws)
    this.ws2 = this.$socket
    this.ws2.onmessage = (message) => {
      try {
        JSON.parse(message.data)
      } catch (e) {
        return false
      }
      let json_data = JSON.parse(message.data)
      json_data = JSON.parse(json_data.message)
      console.log(json_data);
      let sender = json_data['sender']
      console.log(sender, this.$store.state.auth.profile.id, 'unscheduled' in json_data)
      if (sender !== this.$store.state.auth.profile.id) {
        if ('remove_route' in json_data) {
          console.log('removing route')
          this.routes = this.routes.filter(a => a.id !== parseInt(json_data['remove_route']))
          return
        }
        if ('unscheduled' in json_data) {
          console.log('updating unscheduled')
          const unscheduled = json_data['unscheduled']
          console.log(unscheduled)
          if (unscheduled.schedule === this.schedule.id) {
            this.unscheduled = unscheduled
          }
          return
        }
        const route = json_data['route']
        console.log('data from socket - ')
        console.log(route)
        if (!moment(route.date).isBetween(this.from, this.to, undefined, '[]')) {
          // an updated route may have been moved to outside the viewers current range
          const ind = this.routes.findIndex(a => a.id === route.id)
          if (ind !== -1) {
            this.routes.splice(ind, 1, route)
          }
          return
        }
        if (route.schedule !== this.schedule.id) { return }
        const index = this.routes.findIndex(a => a.id === route.id)
        if (index === -1) {
          this.routes.push(route)
        } else {
          this.routes.splice(index, 1, route)

          // check to see if the route coming in will change the selection status of something the user is working on.
          console.log('checking for selection change')
          this.checkUpdateForSelectionChanges(route)
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.state.nav.showDrawer = true
    this.$store.dispatch('clearSubnav')
    this.$store.dispatch('clearExtraNav')
    next()
  },
  beforeRouteUpdate(to, from, next) {
    if (from.params.id != to.params.id) {
      this.getData(to.params.id)
    }
    next()
  },
  methods: {
    async getData() {
      await this.getSchedule()
      this.getScheduleData()
      this.getUnscheduled()
    },

    async getSchedule() {
      this.isLoading = true
      this.subNav = []
      this.extraNav = []
      this.unscheduled = []
      let tmp = await scheduleAPI.getSchedules()
      this.activeSchedules = _.filter(tmp, s => s.is_archived === false && s.division)
      this.activeCalendars = _.filter(tmp, s => s.is_archived === false && !s.division)
      this.schedule = _.find(tmp, s => s.id == this.$route.params.id)
      this.activeSchedules.forEach(s => {
        this.subNav.push({
          title: s.name,
          icon: _.find(this.$store.state.misc.divisions, d => d.id == s.division).icon,
          route: { name: 'ScheduleDay', params: { id: s.id, date: moment().format('YYYY-MM-DD').toString() } }
        })
      })
      this.activeCalendars.forEach(c => {
        this.extraNav.push({
          title: c.name,
          icon: 'mdi-calendar',
          route: { name: 'OfficeCalendar', params: { id: c.id, date: moment().format('YYYY-MM-DD').toString() } }
        })
      })
      if (this.subNav.length) {
        this.$store.dispatch('loadSubnavTitle', 'Work Order Schedules')
        this.$store.dispatch('loadSubnav', this.subNav)
      }
      if (this.extraNav.length) {
        this.$store.dispatch('loadExtraNavTitle', 'Calendars')
        this.$store.dispatch('loadExtraNav', this.extraNav)
      }
      this.isLoading = false
    },

    async getUnscheduled() {
      this.isLoadingUnscheduled = true
      // Putting this here, just in case the page is too slow and we need the schedule object faster
      if (!this.schedule) {
        this.schedule = await scheduleAPI.getScheduleObj(this.$route.params.id)
      }
      this.unscheduled = await scheduleAPI.getUnscheduledWOs(this.$route.params.id)
      // if installs appear here, need to make changes to backend so the service schedule doesn't get those wos.

      this.isLoadingUnscheduled = false
    },

    async getScheduleData() {
      console.log('get schedule data')
      this.isLoadingCalData = true
      this.clearScheduleData()
      if (!this.schedule) {
        this.schedule = await scheduleAPI.getScheduleObj(this.$route.params.id)
      }
      this.routes = await scheduleAPI.getRoutesForDateRange(this.from, this.to, this.schedule.id)
      // console.log('base: from = ' + this.from)
      // console.log('base: to = ' + this.to)

      // check to see if the route is currently in the store, and replace it. (this maintains selected status on view change)
      this.storeRoutes.forEach(route => {
        let index = this.routes.findIndex(r => r.id === route.id)
        if (index !== -1) {
          this.routes[index] = route
          console.log('replacing route - ' + route.id)
          console.log(route)
        }
      })

      // need to add get reminders here when available.
      this.isLoadingCalData = false
    },

    dateChange(from, to) {
      // Each calendar type will emit "dateChange" when the user clicks "previous" or "next"
      // at the top of the calendar. That will trigger this function, which will update the dates
      // and re-GET the data from the API
      if (this.from === from && this.to === to) {
        return
      }
      this.from = from
      this.to = to
      this.getScheduleData()
    },

    clearScheduleData() {
      this.routes = []
      // deal with reminders here when available
    },

    checkUpdateForSelectionChanges(route) {
      if (this.storeRoutes.find(r => r.id === route.id)) {
        console.log('checking for selection changes')
        console.log(this.storeRoutes.find(r => r.id === route.id))
        console.log(route)
        console.log(this.storeRoutes)
        this.$store.dispatch('deselectAll')
        this.$store.dispatch('selectScheduleError')
      }
    },
    async addRoute(route) {
      route.schedule = this.schedule.id;
      const newRoute = await scheduleAPI.createRoute(route);
      this.routes.push(newRoute)
      if (this.$store.state.schedule.selectedWOs.length > 0) {
        this.moveWOs(newRoute.id)
      }
    },
    async deleteRoute(route) {
      if (route.wos && route.wos.length > 0) {
        this.$store.dispatch('deselectAll')
        this.$store.dispatch('addWOGroup', route.wos)
        this.$store.dispatch('selectRoute', route)
        await this.moveWOs()
      }
      scheduleAPI.deleteRoute(route)
      this.routes = miscServices.removeObject(this.routes, route)
    },
    async updateRoute(route) {
      // update route toggles attempted from true to false on the backend if the date has changed
      let tmpRoute = await scheduleAPI.updateRoute(route);
      if (moment(tmpRoute.date, 'YYYY-MM-DD').isBefore(moment(this.from), 'YYYY-MM-DD') || moment(tmpRoute.date, 'YYYY-MM-DD').isAfter(moment(this.to), 'YYYY-MM-DD')) {
        this.routes = miscServices.removeObject(this.routes, tmpRoute)
      } else {
        this.routes = miscServices.replaceObject(this.routes, tmpRoute)
      }
    },
    async getFullRoute(routeID) {
      // in week and month view, routes are loaded without the wos attached. this function gets the route with the wos attached
      this.routesLoading += 1
      let fullRoute = await scheduleAPI.getRoute(routeID)
      this.routes = miscServices.replaceObject(this.routes, fullRoute)
      this.routesLoading -= 1
      return fullRoute
    },
    archiveWOs() {
      // calling function to make sure no routed WOs are included
      this.isLoadingUnscheduled = true
      let selected = _.cloneDeep(this.$store.state.schedule.selectedWOs)
      selected.forEach(w => w.archived = true)
      this.unscheduled.wos = _.pullAllBy(this.unscheduled.wos, selected, 'id')
      selected.forEach(w => wosAPI.updateWO(w))
      this.$store.state.schedule.selectedWOs = []
      this.isLoadingUnscheduled = false
    },
    // unscheduleSelected, insertBefore, & addWOsToRoute have been rewritten into a single function. 
    async moveWOs(routeID = null, beforeWoID = 0) {
      this.isLoadingCalData = true
      let selected = _.cloneDeep(this.$store.state.schedule.selectedWOs)
      let targetArray = routeID ? this.routes[this.routes.findIndex(r => r.id === routeID)].wos : this.unscheduled.wos
      let routesByIdThatNeedUpdate = []
      if (routeID) { // we're moving wos to a route
        // add this routeID to the list of routes that'll need an update.
        routesByIdThatNeedUpdate.push(routeID)
        // and check to see if the target is a route with no wos array (ie - hasn't been opened), and if so... get it.
        if (targetArray === null) {
          await this.getFullRoute(routeID)
          targetArray = this.routes[this.routes.findIndex(r => r.id === routeID)].wos
        }
      } else {  // we're moving wos to unscheduled (routeID will be set to null by calling function)
        // check to see if any selected wos are already unscheduled, and if so we can from them from processing
        let unscheduledID = this.unscheduled.id
        let alreadyUnscheduled = _.filter(selected, function (w) { return w.route === unscheduledID })
        if (alreadyUnscheduled.length) {
          this.$refs.unscheduled.deselectAll()
          _.pullAllBy(selected, alreadyUnscheduled, 'id')
        }
      }
      if (selected.length > 0) {
        // process all the wos (by first removing them from where they are, then adding them to the destination at the end)
        for (let a = 0; a < selected.length; a++) {
          if (selected[a].route && selected[a].route !== this.unscheduled.id) {  // if it was in a route
            // find which route its in
            let oldRouteIndex = this.routes.findIndex(r => r.id === selected[a].route)
            // remove it from that route (if it's still on the same page/view where he selected it from) 
            if (oldRouteIndex !== -1) {
              // but... also check to see the user hasn't navigated to a view where the route still exists, but wos aren't loaded anymore.
              if (this.routes[oldRouteIndex].wos === null) {
                await this.getFullRoute(this.routes[oldRouteIndex].id)
              }
              miscServices.removeObject(this.routes[oldRouteIndex].wos, selected[a])
            }
            // also remove it from the store copy (store copy is used for update)
            // we could just replace the store copy of the route here as well, but either is two lines of code. 
            oldRouteIndex = this.storeRoutes.findIndex(r => r.id === selected[a].route)
            miscServices.removeObject(this.storeRoutes[oldRouteIndex].wos, selected[a])
            // add this routeID to the list of routes that'll need an update at the end.
            routesByIdThatNeedUpdate.push(selected[a].route)
          } else {  // if it was unscheduled
            // remove it from unscheduled
            miscServices.removeObject(this.unscheduled.wos, selected[a])
          }
          // update values (routeID will be set to null by the calling function if wos are intended to be unscheduled)
          // if (selected[a].route !== routeID) {
          //   selected[a].is_attempted = false
          // }
          selected[a].route = routeID
          selected[a].is_selected = false
        }
        // if 'inserting before' find the index to insert new wos before, otherwise add them to the end
        let beforeWoIndex = beforeWoID ? targetArray.findIndex(w => w.id === beforeWoID) : targetArray.length
        targetArray.splice(beforeWoIndex, 0, ...selected)
        if (routeID) {
          // pass the updated copy of the target route into the store so it's ready for the api update
          let targetRoute = _.cloneDeep(this.routes.find(r => r.id === routeID))
          await this.$store.dispatch('selectRoute', targetRoute)
        }
        // find all routes that wos have come from and/or went to and get their new wos array order to be sent to the backend for update.
        routesByIdThatNeedUpdate = _.uniq(routesByIdThatNeedUpdate)
        let routeUpdateArray = []
        routesByIdThatNeedUpdate.forEach(r => routeUpdateArray.push(this.getUpdateRouteObject(r)))
        scheduleAPI.updateRouteWos(routeUpdateArray)
      }
      this.$store.dispatch('deselectAll')
      this.isLoadingCalData = false
    },
    getUpdateRouteObject(routeID) {
      // assumes routes that require update have been properly copied into the store
      let wosIdArray = []
      let route = this.$store.state.schedule.selectedRoutes.find(r => r.id === routeID)
      route.wos.forEach(w => wosIdArray.push(w.id))
      let routeUpdateObject = { 'routeID': routeID, 'wos': wosIdArray }
      return routeUpdateObject
    },
    select(woArray) {
      let tmpRoutes = []
      for (let a = 0; a < woArray.length; a++) {
        if (!(woArray[a].route === null || woArray[a].route === this.unscheduled.id)) {
          tmpRoutes.push(woArray[a].route);
        }
        woArray[a].is_selected = true;
      }
      this.$store.dispatch('addWOGroup', woArray)
      tmpRoutes = _.uniq(tmpRoutes)

      //hopefully this method doesn't slow things down, but it means this command could handle wos coming from separate routes
      tmpRoutes.forEach(tempRoute => this.$store.dispatch('selectRoute', _.cloneDeep(this.routes.find(r => r.id === tempRoute))))
    },
    deselect(woArray) {
      // the calling component is assumed to provide the filtered list of ONLY wos within the route that need to be de-selected
      let tmpWO = {}
      for (let a = 0; a < woArray.length; a++) {
        if (woArray[a].route === null || woArray[a].route === this.unscheduled.id) {
          tmpWO = this.unscheduled.wos.find(w => w.id === woArray[a].id)
        } else {
          let index = this.routes.findIndex(r => r.id === woArray[a].route)
          tmpWO = this.routes[index].wos.find(w => w.id === woArray[a].id)
        }
        tmpWO.is_selected = false
      }
      this.$store.dispatch('removeWOGroup', woArray)
      // no need to deal with selectedRoute Array in store here. (the selectedRoutes array is cleared once any wos actually move)
      // storeRoutes may have extra data stored in it from time to time, but it shouldn't cause an issue - MJ
      // (at least it didn't before we built the alert/deselection system for other users who are working on the same schedule)
      // currently, it could cause a phantom scheduleErrorAlert even if you don't have stuff selected.  Might need to deal with this - MJ.
      // this may be more even more important with 'deselect all' coming from shifter component (routes are currently left in store).
      // Matt will come back to this at some point and get it working properly.
      // (need to run a check against each route left in the store, if there's any wos still selected from a storeRoute, leave it in. otherwise remove) 
    },
    openQuickView(wo) {
      this.woQV = _.cloneDeep(wo);
      this.showQuickView = true;
    },
    openCrewVisits(wo) {
      this.woCV = _.cloneDeep(wo);
      this.showCrewVisits = true;
    },
    updateQuickView(wo) {
      this.woQV = wo;
      let tmp = _.cloneDeep(this.woQV);
      _.forOwn(tmp, function (value, key) {
        if (_.has(wo, key) && (value !== wo[key])) {
          tmp[key] = wo[key]
          console.log(key + ' updated from ' + value + ' to ' + wo[key])
        }
      })
      let routeIndex = this.routes.findIndex(r => r.id === tmp.route)

      if (routeIndex !== -1) {
        miscServices.replaceObject(this.routes[routeIndex].wos, tmp)
      } else {
        miscServices.replaceObject(this.unscheduled.wos, tmp);
      }
    },
    nextWO() {
      if (!this.woQV.scheduled) {
        for (let i = 0; i < this.unscheduled.wos.length; i++) {
          if (this.unscheduled.wos[i].id === this.woQV.id) {
            this.woQV = this.unscheduled.wos[i + 1] ?? this.unscheduled.wos[0];
            break;
          }
        }
      }
      else {
        for (let i = 0; i < this.routes.length; i++) {
          let found = false;
          if (this.routes[i].id === this.woQV.route) {
            for (let j = 0; j < this.routes[i].wos.length; j++) {
              if (this.routes[i].wos[j].id === this.woQV.id) {
                this.woQV = this.routes[i].wos[j + 1] ?? this.routes[i].wos[0];
                found = true;
                break;
              }
            }
            if (found) {
              break;
            }
          }
        }
      }
    },
    prevWO() {
      if (!this.woQV.scheduled) {
        for (let i = 0; i < this.unscheduled.wos.length; i++) {
          if (this.unscheduled.wos[i].id === this.woQV.id) {
            this.woQV = this.unscheduled.wos[i - 1] ?? this.unscheduled.wos[this.unscheduled.wos.length - 1];
            break;
          }
        }
      }
      else {
        for (let i = 0; i < this.routes.length; i++) {
          let found = false;
          if (this.routes[i].id === this.woQV.route) {
            for (let j = 0; j < this.routes[i].wos.length; j++) {
              if (this.routes[i].wos[j].id === this.woQV.id) {
                this.woQV = this.routes[i].wos[j - 1] ?? this.routes[i].wos[this.routes[i].wos.length - 1];
                found = true;
                break;
              }
            }
            if (found) {
              break;
            }
          }
        }
      }
    }
  },
  components: {
    'unscheduled': Unscheduled,
    'wo-quick-view': woQuickView,
    'crew-visits-dialog': CrewVisitsDialog
  }
}
</script>

<style>
.unscheduled {
  border: 0px solid yellow;
  padding-left: 16px;
  display: flex;
}

.main-wrapper {
  display: flex;
}

.schedule-view {
  border: 0px solid purple;
  width: 100%;
}

.main-container {
  border: 0px solid black;
  overflow-x: auto;
}

.schedule-container {
  border-right: 0px solid grey;
  display: flex;
  overflow-x: auto;
  max-width: calc(95vw - 230px - 256px) !important;
  min-width: 600px !important;
  margin-left: 16px !important;
  margin-right: 16px !important;
}

.schedule-container-expanded-weekview {
  border-right: 0px solid grey;
  display: flex;
  max-width: calc(95vw - 230px) !important;
  min-width: 600px !important;
  margin-left: 16px !important;
  margin-right: 16px !important;
}

.schedule-container-expanded {
  border-right: 0px solid grey;
  display: flex;
  overflow-x: auto;
  max-width: calc(95vw - 230px) !important;
  min-width: 600px !important;
  margin-left: 16px !important;
  margin-right: 16px !important;
}

.schedule-items-wrapper {
  max-width: 100%;
}

.schedule-items {
  border-top: 0px solid green;
  overflow-x: auto;
  padding-left: 16px !important;
  margin-right: 20px !important;
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.schedule-items-box {
  min-width: 220px !important;
  margin-top: 0px;
  padding-bottom: 10px;
  padding-left: 0px;
  padding-right: 00px;
}

.title-div {
  min-width: 500px !important;
  margin-right: 20px !important;
}
</style>
